import React, { useState } from "react";
import { useAluno } from "@/hooks/alunos";
import { telefone } from "@/formatters";
import { FaPen } from "react-icons/fa";
import { Modal } from "@/components/Common";
import ModalEditContato from "./ModalEditContato";
import { Container, CircleButton } from "./styles";

export default function Endereco() {
  const { aluno } = useAluno();
  const [modalEditOpen, setModalEditOpen] = useState(false);

  return (
    <Container>
      <h4>Contato:</h4>
      <p>
        {telefone(aluno.telefone)}
        <br />
        {aluno.usuario.email}
      </p>
      <div className="actions">
        <CircleButton onClick={() => setModalEditOpen(true)}>
          <FaPen size={10} />
        </CircleButton>
      </div>
      <Modal open={modalEditOpen} onClose={() => setModalEditOpen(false)}>
        <ModalEditContato onClose={() => setModalEditOpen(false)} />
      </Modal>
    </Container>
  );
}
